var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c(_vm.getLayoutName,{tag:"component"}),_c('div',{staticClass:"vld-parent"},[_c('loading',{attrs:{"active":_vm.$store.state.isLoading,"can-cancel":true,"is-full-page":true},on:{"update:active":function($event){return _vm.$set(_vm.$store.state, "isLoading", $event)}}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }